import { createAction } from "@coverme/redux";
import Axios from "axios";

export const getCustomer = () =>
    createAction("GET_CUSTOMER", () =>
        Axios.get("api/customer/")
            .then(x => {
                if (x.data === "") {
                    return {};
                } else {
                    return x.data;
                }
            })
            .catch(error => {
                if (error.response.status === 404) {
                    return null;
                } else {
                    throw error;
                }
            })
    );

export const getSelectedCustomer = customerId =>
    createAction("GET_SELECTED_CUSTOMER", () =>
        Axios.get("api/customer/" + (customerId !== null && customerId !== undefined ? customerId : ""))
            .then(x => {
                if (x.data === "") {
                    return {};
                } else {
                    return x.data;
                }
            })
            .catch(error => {
                if (error.response.status === 404) {
                    return null;
                } else {
                    throw error;
                }
            })
    );

export const getChildFacilities = customerId =>
    createAction("GET_CHILD_FACILITIES", () =>
        Axios.get(customerId === undefined ? "api/customers/all" : "api/customers/" + customerId + "/children/full")
            .then(x => x.data)
            .catch(error => {
                if (error.response.status === 404) {
                    return null;
                } else if (error.response.status === 403) {
                    return [];
                } else {
                    throw error;
                }
            })
    );
